module.exports = __webpack_public_path__ + "static/media/habitat.f6204748.svg";